// 引入路由
// import route from '../router/index.js'

import { API_BASE_URL } from '../config';

var root = API_BASE_URL;
// 引用axios
var axios = require('axios');
// 把Request PayLoad 转成 Form Data
var qs = require('qs');

// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
};

// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
};

/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers['Authorization'] = localStorage.getItem('Authorization');
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// localStorage.setItem('currentPage', '1');

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么

  if (response.data.errCode == 401) { // 401 登录过期

    var currentPage = localStorage.getItem('currentPage2');
    var currentPage3 = JSON.parse(localStorage.getItem('currentPage3'));
    sessionStorage.clear();
    localStorage.clear();
    localStorage.setItem('currentPage2', currentPage);
    localStorage.setItem("currentPage3", JSON.stringify(currentPage3));
    localStorage.setItem('currentPage', '/Login');
    var ua = window.navigator.userAgent.toLowerCase();

    window.location.href = '/client/Login';


  } else if (response.data.errCode == 1004) { // 1004 token过期
    localStorage.setItem('Authorization', response.data.data); // 重新赋值token
    window.location.reload();
    sessionStorage.clear();
    // window.location.href = '/';
  }else if(response.data.errCode == 404) {
    window.location.href = "/client/404";
  }
  return response;
}, function (error) {
  if (error.response.status == 401) {

    sessionStorage.clear();
    localStorage.clear();

    window.location.href = '/client/Login';

  }else if(error.response.status == 404) {
    window.location.href = "/client/404";
  }
  // 对响应错误做点什么
  return Promise.reject(error);
});
// if (localStorage.getItem('currentPage') == '/Login') {
//   window.location.href = '/client/Login';
//   // window.location.reload();
//   // localStorage.setItem('currentPage','');
// }

function apiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,

    // 允许请求的数据在传到服务器之前进行转 把Request PayLoad 转成 Form Data
    transformRequest: [function (params) {
      // return qs.stringify(params, {arrayFormat: 'brackets'});
      return qs.stringify(params)
    }],

    // 自定义的要被发送的头信息
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; chartset=UTF-8'
    },

    baseURL: root,

    withCredentials: false
  })

    .then(function (res) {

      if (res.data.errCode == 0) {
        if (success) {
          success(res.data)
        }
      } else {
        if (failure) {
          failure(res.data)
        }
      }

    })
    .catch(function (err) {
    })
}

function apiAxiosJson(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,

    // 自定义的要被发送的头信息
    headers: {
      'Content-Type': 'application/json'
    },

    baseURL: root,

    //　是否跨域请求
    withCredentials: false
  })
    .then(function (res) {
      if (res.data.errCode == 0) {
        if (success) {
          success(res.data)
        }
      } else {
        if (failure) {
          failure(res.data)
        }
      }
    })
    .catch(function (err) {
    })
}

// 上传
function uploadApiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,

    // 允许请求的数据在传到服务器之前进行转 把Request PayLoad 转成 Form Data
    transformRequest: [function (params) {
      // return qs.stringify(params, {arrayFormat: 'brackets'});
      return params
    }],

    // 自定义的要被发送的头信息
    headers: {
      'Content-Type': 'multipart/form-data'
    },

    baseURL: root,

    //　是否跨域请求
    withCredentials: false
  })

    .then(function (res) {

      if (res.data.errCode == 0) {
        if (success) {
          success(res.data)
        }
      } else {
        if (failure) {
          failure(res.data)
        }
      }

    })
    .catch(function (err) {

    })
}

// 导出
function exportApiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    responseType: 'blob', // 表明返回服务器返回的数据类型
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,

    // 允许请求的数据在传到服务器之前进行转 把Request PayLoad 转成 Form Data
    transformRequest: [function (params) {
      // return qs.stringify(params, {arrayFormat: 'brackets'});
      return params
    }],

    // 自定义的要被发送的头信息
    headers: {
      'Content-Type': 'application/json'
    },
    baseURL: root,
    //　是否跨域请求
    withCredentials: false
  })

    .then(function (res) {
      //创建一个隐藏的a连接，
      //  const link = document.createElement('a');
      //  let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
      //  link.style.display = 'none';
      //  //设置连接
      //  link.href = URL.createObjectURL(blob);
      //  link.download = '学生信息表';
      //  document.body.appendChild(link);
      //  //模拟点击事件
      //  link.click();
    })
    .catch(function (err) {
    })
}

// 返回在vue模板中的调用接口
export default {
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },
  postJson: function (url, params, success, failure) {
    return apiAxiosJson('POST', url, params, success, failure)
  },
  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure)
  },
  // 上传图片
  uploadPost: function (url, params, success, failure) {
    return uploadApiAxios('POST', url, params, success, failure)
  },
  // 导出
  exportPost: function (url, params, success, failure) {
    return exportApiAxios('GET', url, params, success, failure)
  },
  root
}
